import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
const stableImage = 'https://cdn.magicpatterns.com/patterns/generated-images/10331bcd-ccfc-4bb8-95eb-07de88f0c830.jpg';
export function RulesSection() {
  const {
    t
  } = useLanguage();
  return <section id="rules" aria-labelledby="rules-title" className="scroll-mt-16 bg-cream py-20 lg:py-28" data-id="element-264" data-mp="3g56ywodgyi5x">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 lg:grid-cols-12 lg:px-8" data-id="element-265" data-mp="3b6can6wqg1ef">
        <div className="lg:col-span-4" data-id="element-266" data-mp="2nivu11itxv3b">
          <h2 id="rules-title" className="font-serif text-4xl font-bold text-bark md:text-5xl" data-id="element-267" data-mp="2ik1afxd1g2i5">{t.rules.title}</h2>
          <p className="mt-4 text-lg leading-relaxed text-bark/75" data-id="element-268" data-mp="2x8nlvnzjoa43">{t.rules.intro}</p>
          <div className="mt-8 hidden aspect-[4/5] overflow-hidden rounded-lg lg:block" data-id="element-269" data-mp="2sh5kwzxiu9j4">
            <img src={stableImage} alt="" className="h-full w-full object-cover" loading="lazy" data-id="element-270" data-mp="24ruvufpja3kt" />
          </div>
        </div>
        <dl className="grid gap-x-10 gap-y-10 sm:grid-cols-2 lg:col-span-8" data-id="element-271" data-mp="1zrypwaxa022m">
          {t.rules.items.map(item => <div key={item.title} className="border-t border-line pt-5" data-id="element-272" data-mp="1yhgiaysr0aha">
              <dt className="font-serif text-xl font-bold text-bark" data-id="element-273" data-mp="22is40t8i4bk7">{item.title}</dt>
              <dd className="mt-2 leading-relaxed text-bark/75" data-id="element-274" data-mp="279ryzsy28jk2">{item.text}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}